var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.5C9.5 8.6 8.6 9.5 7.5 9.5C6.4 9.5 5.5 8.6 5.5 7.5C5.5 6.4 6.4 5.5 7.5 5.5C8.6 5.5 9.5 6.4 9.5 7.5ZM15 7.5C15 13.58 10.33 17.39 8.33 18.74C8.08 18.92 7.79 19 7.5 19C7.21 19 6.92 18.92 6.66 18.74C4.66 17.39 0 13.59 0 7.5C0 3.22 3.22 0 7.5 0C11.77 0 15 3.22 15 7.5ZM11.5 7.5C11.5 5.29 9.71 3.5 7.5 3.5C5.29 3.5 3.5 5.29 3.5 7.5C3.5 9.71 5.29 11.5 7.5 11.5C9.71 11.5 11.5 9.71 11.5 7.5Z",
    fill: "url(#paint0_linear_257_2247)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_257_2247",
    x1: 12.1721,
    y1: -2.23366,
    x2: -5.04529,
    y2: 6.38422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3465BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00338D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cc548a3419b37f43a16e139dc6addcae.svg";
export { ForwardRef as ReactComponent };